import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PenLine } from "lucide-react";
import { chf, imgSrc } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  const hasDiscount = product.discount_percent > 0;
  const finalPrice = hasDiscount
    ? product.price * (1 - product.discount_percent / 100)
    : product.price;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.19, 1, 0.22, 1] }}
    >
      <Link to={`/produit/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
        <div className="relative aspect-[4/5] overflow-hidden border border-line bg-sand">
          {hasDiscount && (
            <span className="absolute left-3 top-3 z-10 bg-terra px-3 py-1 text-xs font-medium uppercase tracking-wider text-white">
              -{product.discount_percent}%
            </span>
          )}
          {product.technique && (
            <span
              data-testid={`technique-badge-${product.id}`}
              className={`absolute right-3 top-3 z-10 px-2.5 py-1 text-[10px] font-medium uppercase tracking-wider backdrop-blur-sm ${
                product.technique === "Gravure laser" ? "bg-ink/85 text-cream" : "bg-cream/85 text-ink"
              }`}
            >
              {product.technique}
            </span>
          )}
          {product.customizable && (
            <span
              data-testid={`customizable-badge-${product.id}`}
              className="absolute bottom-3 left-3 z-10 flex items-center gap-1.5 bg-cream/90 px-2.5 py-1 text-[10px] font-medium uppercase tracking-wider text-ink backdrop-blur-sm"
            >
              <PenLine className="h-3 w-3 text-terra" /> Personnalisable
            </span>
          )}
          <img
            src={imgSrc(product.image_url)}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-x-0 bottom-0 translate-y-full bg-ink/90 py-3 text-center text-xs uppercase tracking-widest text-cream transition-transform duration-500 group-hover:translate-y-0">
            {product.customizable ? "Personnaliser →" : "Commander →"}
          </div>
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div>
            <p className="text-[11px] uppercase tracking-widest text-ink3">{product.category}</p>
            <h3 className="mt-1 font-serif text-xl font-medium leading-tight text-ink">{product.name}</h3>
          </div>
          <div className="text-right">
            {hasDiscount && <p className="text-xs text-ink3 line-through">{chf(product.price)}</p>}
            <p className="font-medium text-ink">{chf(finalPrice)}</p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
